import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders } from '../../configuration/tokenHandling/prepareHeaders';
import type { MonitorDefinition } from '../../domain/model/Monitor.types';
import * as api from './generated/api';
import { toMonitorDefinitions } from './monitors.mapper';

const baseUrl = `${import.meta.env.VITE_IOT_DATA_QUALITY_MONITOR_URL}`;

const MONITORS_TAG = 'MonitorDefinitions';

export const monitorsApi = createApi({
    reducerPath: 'monitorsApi',
    tagTypes: [MONITORS_TAG],
    baseQuery: fetchBaseQuery({ baseUrl, prepareHeaders }),
    endpoints: builder => ({
        getAllMonitors: builder.query<MonitorDefinition[], void>({
            query: () => ({
                url: 'monitors',
            }),
            transformResponse: (response: unknown) => {
                const data = api.MonitorList.parse(response);
                return toMonitorDefinitions(data);
            },
            providesTags: [MONITORS_TAG],
        }),
        // Additional endpoints can be added here if needed
    }),
});

export const { useGetAllMonitorsQuery } = monitorsApi;
